import { useEffect, useState } from "react";
import "./termsandcondition.css";
import { submitRegretApi } from "../api/api";

const RegretButton = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const fullName = String(data.get("fullName") || "").trim();
    const orderNumber = String(data.get("orderNumber") || "").trim();
    const dni = String(data.get("dni") || "").trim();
    const email = String(data.get("email") || "").trim();

    if (isSubmitting) return;
    if (!acceptedTerms) {
      setStatus({
        type: "error",
        message: "Debés confirmar que leíste los Términos y Condiciones.",
      });
      return;
    }
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      await submitRegretApi({ fullName, orderNumber, dni, email });
      setStatus({
        type: "success",
        message: "Solicitud enviada. Te contactaremos a la brevedad.",
      });
      form.reset();
      setAcceptedTerms(false);
    } catch (error) {
      const fallbackMessage =
        error?.response?.data?.message || "No pudimos enviar la solicitud. Reintentá en unos minutos.";
      setStatus({ type: "error", message: fallbackMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="terms-page">
      <header className="terms-hero">
        <div className="terms-hero-inner pading150">
          <span className="terms-pill">Plataforma Ticketera ZOCO</span>
          <h1 className="terms-title">Botón de arrepentimiento</h1>
          <p className="terms-subtitle">
            Completá este formulario para ejercer el derecho de arrepentimiento.
          </p>
        </div>
      </header>

      <div className="terms-content pading150">
        <div className="terms-card">
          <section className="terms-section" style={{ "--section-index": 0 }}>
            <h2>Formulario de arrepentimiento</h2>
            <p>
              Debido a que las entradas corresponden a servicios con fecha determinada de ejecución (el evento), el derecho de arrepentimiento podrá ejercerse hasta 48 (cuarenta y ocho) horas antes del inicio del evento, y siempre dentro del plazo máximo de diez (10) días corridos desde la compra, lo que ocurra primero.
              Las entradas transferidas no podrán ser objeto del derecho de arrepentimiento, dado que el acto de transferencia se considera oneroso entre particulares.
              <a className="terms-link-strong terms-link-offset" href="/termsandcondition">
                Ver más
              </a>
            </p>
            <p>El consumidor deberá informar exclusivamente:</p>
            <ul>
              <li>nombre y apellido,</li>
              <li>número de orden o transacción,</li>
              <li>DNI,</li>
              <li>correo electrónico registrado en la compra.</li>
            </ul>
            <form className="terms-form" onSubmit={handleSubmit}>
              <div className="terms-form-grid">
                <label className="terms-form-field">
                  <span>Nombre y apellido</span>
                  <input
                    className="terms-form-input"
                    type="text"
                    name="fullName"
                    required
                  />
                </label>
                <label className="terms-form-field">
                  <span>Número de orden de la entrada</span>
                  <input
                    className="terms-form-input"
                    type="text"
                    name="orderNumber"
                    required
                  />
                </label>
                <label className="terms-form-field">
                  <span>DNI</span>
                  <input
                    className="terms-form-input"
                    type="text"
                    name="dni"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    required
                  />
                </label>
                <label className="terms-form-field">
                  <span>Correo electrónico</span>
                  <input
                    className="terms-form-input"
                    type="email"
                    name="email"
                    required
                  />
                </label>
              </div>
              <label className="terms-form-consent">
                <input
                  className="terms-form-checkbox"
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={(event) => setAcceptedTerms(event.target.checked)}
                  required
                />
                <span>
                  Confirmo que leí los{" "}
                  <a className="terms-link-strong" href="/termsandcondition">
                    Términos y Condiciones
                  </a>
                  .
                </span>
              </label>
              <div className="terms-form-actions">
                <button
                  type="submit"
                  className="terms-form-button"
                  disabled={isSubmitting || !acceptedTerms}
                >
                  {isSubmitting ? "Enviando..." : "Enviar solicitud"}
                </button>
              </div>
              {status.message && (
                <p
                  className={`terms-form-status ${status.type === "error" ? "is-error" : "is-success"}`}
                  aria-live="polite"
                >
                  {status.message}
                </p>
              )}
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RegretButton;
